// Chakra imports
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import { Icon } from "@chakra-ui/react";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { FcDeleteDatabase } from "react-icons/fc";

export default function Information(props) {
  const {
    title,
    description,
    value,
    onClick,
    selectedDocumentTypeID,
    id,
    isActive,
    onClickIcon,
    ...rest
  } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const bg = useColorModeValue("white", "navy.700");
  return (
    <Card
      onClick={onClick}
      bg={bg}
      {...rest}
      border="2px"
      borderColor={selectedDocumentTypeID === id ? "#422AFB" : "white"}
      display="flex"
      flexDir="row"
      alignItems="center"
      justifyContent="space-between"
      _hover={{
        border: "2px",
        borderColor: "#422AFB",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add a box shadow on hover
      }}
    >
      <Box marginRight="5px">
        <Text color={textColorPrimary} fontWeight="500" fontSize="md">
          {value}
        </Text>
        <Text fontWeight="500" color={textColorSecondary} fontSize="sm">
          {title}
        </Text>
        <Text fontWeight="500" color={textColorSecondary} fontSize="sm">
          {description}
        </Text>
      </Box>
      {selectedDocumentTypeID === id ? (
        <Icon
          onClick={isActive ? onClickIcon : null}
          w="32px"
          h="32px"
          color="green.500"
          as={isActive ? BsFillArrowRightCircleFill : FcDeleteDatabase}
          _hover={{
            width: "34px", // Add a box shadow on hover
          }}
        />
      ) : (
        <Icon w="32px" h="32px" color="white" as={BsFillArrowRightCircleFill} />
      )}
    </Card>
  );
}
